import { Building, Site } from '../../confi-state';
import { ServiceManager } from '../../services/service-manager';
import styles from './SiteInfo.module.css';

const SiteInfo = ({ currentSite, buildings }: { currentSite: Site, buildings: Building[] }) => {

    const computeTotalPrice = () => {
        if (buildings && buildings.length > 0) {
            return ServiceManager.buildingHelperService.calculateCostOfSite(buildings).toLocaleString('nl-NL', {
                style: "currency",
                currency: "EUR",
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            })
        } else {
            return 0;
        }
    }

    return (
        <div className={styles.SiteInfo} data-testid="SiteInfo">
            <div>
                <h2>Totaal</h2>
                <div className={styles.half}>
                    <dl>
                        <dt>
                            Oppervlakte
                        </dt>
                        <dd data-testid="SiteArea">
                            {ServiceManager.buildingHelperService.siteArea(currentSite.border).toLocaleString('nl-NL', { minimumFractionDigits: 0, maximumFractionDigits: 0 })} ㎡
                        </dd>
                        <dt>
                            Woningen
                        </dt>
                        <dd data-testid="NrApartments">
                            {ServiceManager.buildingHelperService.calculateTotalAppartmentsOfSite(buildings)}
                        </dd>
                    </dl>
                </div>
                <div className={styles.half}>
                    <dl>
                        <dt>
                            Gebouwen
                        </dt>
                        <dd data-testid="NrOfBuildings">
                            {buildings ? buildings.length : 0}
                        </dd>
                        <dt>
                            Bebouwd
                        </dt>
                        <dd data-testid="PercentageBuiltArea">
                            {ServiceManager.buildingHelperService.calculateBuiltAreaPercentageOfSite(currentSite, buildings).toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%
                        </dd>

                    </dl>
                </div>
            </div>
        </div>
    )
};

export default SiteInfo;
